<p>{{ 'routes.banner' | translate }}</p>
